import globals from '../../api/globals'

// initial state
const state = {
  globals: {auth: 0},
  menuActive: false,
  loginResponse: false,
  translation: {},
  langInitialized: false,
  modalAlert: false,
  chatData: false,
  messageCount: 0,
  taskCount: 0,
  notificationCount: 0
}

// getters
const getters = {
  globals: state => state.globals,
  menuActive: state => state.menuActive,
  loginResponse: state => state.loginResponse,
  translation: state => state.translation,
  langInitialized: state => state.langInitialized,
  modalAlert: state => state.modalAlert,
  chatData: state => state.chatData,
  messageCount: state => state.messageCount,
  taskCount: state => state.taskCount,
  notificationCount: state => state.notificationCount
}

// actions
const actions = {
  getGlobals ({ commit }) {
    globals.getGlobals(globals => {
      commit('RECEIVE_GLOBALS', { globals })
    })
  },
  selectMyMessageCount ({ commit }) {
    globals.selectMyMessageCount(data => {
      commit('RECEIVE_MSG_COUNT', { data })
    })
  },
  selectMyTasksCount ({ commit }) {
    globals.selectMyTasksCount(data => {
      commit('RECEIVE_TASK_COUNT', { data })
    })
  },
  selectMyNotificationsCount ({ commit }) {
    globals.selectMyNotificationsCount(data => {
      commit('RECEIVE_NOTIFICATION_COUNT', { data })
    })
  },
  fetchLanguage: function (context, data) {
    globals.fetchLanguage(data, translation => {
      context.commit('RECEIVE_LANGUAGE', { translation })
    })
  },
  login: function (context, data) {
    globals.login(data, loginResponse => {
      context.commit('LOGIN_RESPONSE', { loginResponse })
      globals.getGlobals(globals => {
        context.commit('RECEIVE_GLOBALS', { globals })
      })
    })
  },
  logout ({ commit }) {
    globals.logout(function(context)
    {
      globals.getGlobals(globals => {
        commit('RECEIVE_GLOBALS', { globals })
      })
    })
  }
}

// mutations
const mutations = {
  ['RECEIVE_GLOBALS'] (state, { globals }) {
    state.globals = globals
  },
  ['RECEIVE_LANGUAGE'] (state, { translation }) {
    state.langInitialized = true;
    state.translation = translation
  },
  ['LOGIN_RESPONSE'] (state, { loginResponse }) {
    state.loginResponse = loginResponse
  },
  ['RECEIVE_MSG_COUNT'] (state, { data }) {
    state.messageCount = data.totalCount
  },
  ['RECEIVE_TASK_COUNT'] (state, { data }) {
    state.taskCount = data.totalCount
  },
  ['RECEIVE_NOTIFICATION_COUNT'] (state, { data }) {
    state.notificationCount = data.totalCount
  },
  setModalAlert: function(state, modalAlert) {
    state.modalAlert = modalAlert
  },
  setChatData: function(state, chatData) {
    state.chatData = chatData
  },
  toggleMenu: state => state.menuActive = !state.menuActive,
  hideMenu: state => state.menuActive = false,
  hideChatMenu: state => state.chatData = false
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/globals.js